import React from 'react';
import { FaLinkedinIn, FaFacebookF, FaYoutube, FaTwitter } from 'react-icons/fa'; // Import icons
import logoImg from '../../assets/logo.png';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer-section">
      <div className="container">
        
        {/* TOP SECTION: Logo, Text, Socials */}
        <div className="footer-top">
          <div className="footer-brand">
            {/* Logo Box */}
            <div className="footer-logo-box">
                <img src={logoImg} alt="Provenance Agri" className="footer-logo" />
            </div>
            <span className="tagline">Where Every Commodity Finds Its Way</span>
            
            <p className="disclaimer">
              By accessing this site you agree that you will not copy or reproduce any part of its contents 
              (including, but not limited to, single prices, graphs or news content) in any form or for 
              any purpose whatsoever without the prior written consent of the publisher.
            </p>
          </div>

          <div className="social-icons">
            <div className="social-icon"><FaLinkedinIn /></div>
            <div className="social-icon"><FaTwitter /></div> {/* Using Twitter icon for 'X' representation */}
            <div className="social-icon"><FaFacebookF /></div>
            <div className="social-icon"><FaYoutube /></div>
          </div>
        </div>

        {/* BOTTOM SECTION: Links & Copyright */}
        <div className="footer-bottom">
          <div className="copyright">
            &copy; 2025 Provenance Agri Supply Chain Solutions Pvt Ltd. All rights reserved.
          </div>
          
          <ul className="footer-links">
            <li>Privacy policy</li>
            <li>Trademarks</li>
            <li>Copyright policy</li>
            <li>Terms of use</li>
            <li>Modern slavery statement</li>
            <li>Careers</li>
            <li>Customer support</li>
            <li>Contact</li>
            <li>Sitemap</li>
          </ul>
        </div>

      </div>
    </footer>
  );
};

export default Footer;